<app-organizer-shared-layout-dashboard [hasHeader]="hasHeader">
  <app-organizer-shared-header
    class="col-span-12 mb-4 lg:col-span-6 lg:mb-3"
    [title]="'organizer.timeslot.pre_schedule.live_url.page.title' | translate"
    [backLink]="backLink"
    [backLinkAriaLabel]="
      'a11y.organizer.timeslot.pre_schedule.live_url.page.title' | translate
    "
  ></app-organizer-shared-header>

  <div class="col-span-12 lg:col-span-5 lg:col-start-2">
    <form [formGroup]="formGroup" (ngSubmit)="submit()">
      <app-form-input-group
        [label]="
          'organizer.timeslot.pre_schedule.live_url.input.live_url.label'
            | translate
        "
        [errors]="formGroup.get('liveUrl').errors"
        errorKey="liveUrl"
        class="block mb-3"
      >
        <app-form-input
          #content
          formControlName="liveUrl"
          type="text"
          [placeholder]="
            'organizer.timeslot.pre_schedule.live_url.input.live_url.placeholder'
              | translate
          "
          [required]="true"
        ></app-form-input>
      </app-form-input-group>

      <app-form-input-group
        [label]="
          'organizer.timeslot.pre_schedule.live_url.input.note_for_attendees.label'
            | translate
        "
        class="block mb-3"
      >
        <app-form-input
          #content
          formControlName="noteForAttendees"
          type="text"
          [placeholder]="
            'organizer.timeslot.pre_schedule.live_url.input.note_for_attendees.placeholder'
              | translate
          "
        ></app-form-input>
      </app-form-input-group>

      <button
        app-vtmn-play-button
        type="submit"
        class="self-start mt-4 w-full md:w-auto"
        [type]="ctaButtonType.Submit"
        [disabled]="isButtonDisabled ? true : null"
        [attr.data-disabled]="isButtonDisabled ? true : null"
      >
        {{ 'organizer.timeslot.pre_schedule.live_url.save_button' | translate }}
      </button>
    </form>

    <app-success-overlay
      *ngIf="isOverlayDisplayed"
      [status]="overlayStatus"
      [loadingTitle]="
        'organizer.timeslot.pre_schedule.live_url.overlay.loading.title'
          | translate
      "
      [loadingDescription]="
        'organizer.timeslot.pre_schedule.live_url.overlay.loading.description'
          | translate
      "
      [successTitle]="'organizer.edit.overlay.success.title' | translate"
      [successDescription]="
        'organizer.timeslot.pre_schedule.live_url.overlay.success.description'
          | translate
      "
    >
      <a app-vtmn-play-button class="md:mx-auto" [routerLink]="backLink.path">
        {{
          'organizer.timeslot.pre_schedule.live_url.overlay.success.button'
            | translate
        }}
      </a>
    </app-success-overlay>
  </div>
</app-organizer-shared-layout-dashboard>
